import { Component, EventEmitter, Output, Input } from '@angular/core';

@Component({
  selector: 'app-alert-modal',
  templateUrl: './alert-modal.component.html',
  styleUrls: ['./alert-modal.component.css']
})
export class AlertModalComponent {
  // visible: boolean = false;
  @Input() isAlertModalVisible!: any;

  @Output() alertModalEventEmitter = new EventEmitter<any>();
  constructor() { }

  ngOnInit() {
    this.isAlertModalVisible;
  }

  deleteEvent(res: any) {
    if(res == 'delete') {
      let res = {isDelete: true, text: 'delete', isModalVisibility: false}
      this.isAlertModalVisible = false;
      this.alertModalEventEmitter.emit(res)
    }
  }

  cancel() {
    let resEmit = {isDelete: false, text: 'cancel',isModalVisibility: false}
    this.isAlertModalVisible = false;
    this.alertModalEventEmitter.emit(resEmit)
  }   
}
